import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  // Suppress PrimeNG accessibility warnings in development
  const originalWarn = console.warn;
  console.warn = function(...args) {
    if (args[0]?.includes?.('aria-hidden')) return;
    originalWarn.apply(console, args);
  };
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
